/**
 * RestaurantMobilePresenter — Mobile UI strategy for restaurants.
 * Reuses ecommerce MobileProductCarousel and FlyToCart for polished UX.
 */
import { MobileProductCarousel } from '../ecommerce/MobileProductCarousel.js';
import { FlyToCart } from '../ecommerce/FlyToCart.js';

export class RestaurantMobilePresenter {

  constructor(config = {}) {
    this.primaryColor = config.primaryColor || '#2563eb';
    this.onItemSelect = config.onItemSelect || (() => {});
    this.carousel = null;
    this.flyToCart = new FlyToCart({
      getCartTarget: () => this._getCartTarget(),
      onCartBump: () => {},
      onRipple: () => {},
    });
  }

  _getCartTarget() {
    const container = document.getElementById('mobile-voice-call-bar-container');
    if (!container) return null;
    const icon = container.querySelector('[data-ttp-fly-target]');
    if (icon) {
      const r = icon.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return icon;
    }
    const fallback = container.querySelector('#ttpFlyToCartTarget');
    if (fallback) {
      const r = fallback.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return fallback;
    }
    return null;
  }

  _handleAddWithFly(cardEl, item) {
    if (this.flyToCart.isAnimating) return;
    this.carousel?.container?.classList.add('ttp-products-animating');
    this.flyToCart.triggerFly(cardEl, item, () => {
      this.carousel?.container?.classList.remove('ttp-products-animating');
      this.onItemSelect(item);
    }, { preferClone: false });
  }

  showMenuItems(items, title) {
    if (!this.carousel) {
      this.carousel = new MobileProductCarousel({
        primaryColor: this.primaryColor,
        onProductAdd: (cardEl, item) => this._handleAddWithFly(cardEl, item),
        onAddDisabled: () => this.flyToCart.isAnimating,
        onClose: () => {},
      });
    }

    const products = items.map(item => ({
      ...item,
      inStock: item.available !== false,
      brand: item.category || '',
      unit: '',
      sellBy: 'quantity',
      cartQuantity: item.orderQuantity || 0,
    }));

    this.carousel.show(products, title);
  }

  hideMenuItems() {
    if (this.carousel) {
      this.carousel.hide();
    }
  }

  onItemAdded(item, cartInfo) {
    if (this.carousel && this.carousel.container) {
      this.carousel.showToast(item.name || item.itemName || 'Item', cartInfo);
    }
    if (cartInfo) {
      this._updateMobileCartRow(cartInfo.itemCount, cartInfo.total, cartInfo.currency);
    }
  }

  updateOrder(info) {
    const count = info.orderItemCount ?? info.itemCount ?? 0;
    const total = info.orderTotal ?? info.total ?? 0;
    this._updateMobileCartRow(count, total, '$');
  }

  _updateMobileCartRow(itemCount, total, currency) {
    const row = document.getElementById('mobileCartRow');
    const textEl = document.getElementById('mobileCartText');
    if (!row || !textEl) return;

    if (itemCount <= 0) {
      row.style.display = 'none';
      return;
    }

    const itemText = `${itemCount} item${itemCount !== 1 ? 's' : ''}`;
    textEl.textContent = `${itemText} · ${currency}${total.toFixed(2)}`;
    row.style.display = 'flex';
  }

  destroy() {
    if (this.flyToCart) this.flyToCart.destroy();
    if (this.carousel) {
      this.carousel.destroy();
      this.carousel = null;
    }
  }
}
